<template>
  <ConfirmationDialog
    :opened="opened"
    :title="title"
    :confirm-btn-label="confirmBtnLabel"
    :cancel-btn-label="cancelBtnLabel"
    :max-width="maxWidth"
    @confirm="onConfirm"
    @cancel="onCancel"
  >
    <div class="d-flex flex-column">
      <AclList
        :acl="usersWithoutPermission"
        :description="descriptionUser"
      />
      <AclList
        :acl="groupsWithoutPermission"
        :description="descriptionGroup"
      />
    </div>
  </ConfirmationDialog>
</template>
<script>
import ConfirmationDialog from '../dialog/ConfirmationDialog';
import AclList from './AclList';


export default {
  name: 'MissingUserPermission',
  components: {
    ConfirmationDialog,
    AclList,
  },
  props: {
    acl: {
      type: Array,
      required: true,
    },
    newAcl: {
      type: Array,
      required: true,
    },
    maxWidth: {
      type: String,
      default: '580px',
    },
    opened: {
      type: Boolean,
      default: false,
    },
    confirmBtnLabel: {
      type: String,
      required: true,
    },
    cancelBtnLabel: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    descriptionUser: {
      type: String,
      required: true,
    },
    descriptionGroup: {
      type: String,
      required: true,
    },
  },
  computed: {
    newUserAcl() {
      return this.newAcl.filter(acl => acl.entityType === 'User');
    },
    newGroupAcl() {
      return this.newAcl.filter(acl => acl.entityType === 'Group');
    },
    usersWithoutPermission() {
      return this.newUserAcl.filter(acl => !this.userHasAccess(acl));
    },
    groupsWithoutPermission() {
      return this.newGroupAcl.filter(acl => !this.groupHasAccess(acl));
    },
    entitiesWithoutPermission() {
      return this.usersWithoutPermission.concat(this.groupsWithoutPermission);
    },
  },
  methods: {
    userHasAccess(userAcl) {
      // TODO: User is in group acl
      return this.acl.some(acl => acl.entityId === userAcl.entityId);
    },
    groupHasAccess(groupAcl) {
      return this.acl.some(acl => acl.entityId === groupAcl.entityId);
    },
    onConfirm() {
      this.$emit('confirm', this.entitiesWithoutPermission);
    },
    onCancel() {
      this.$emit('cancel');
    },
  },
  watch: {
    opened() {
      if (this.opened && this.entitiesWithoutPermission.length === 0) {
        this.onConfirm();
      }
    },
  },
};
</script>
